(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/models/sportkryss.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/models/sportkryss.js'); (function(Backbone, _, svs) {
  'use strict';

  svs.tipset.models.Sportkryss = Backbone.Model.extend({
    defaults: {
      sportkryssNr: null,
      sportkryssAmount: 0,
      sportkryssBet: null,
      defaultsportkryssAmount: 0,
      isValid: true
    },

    initialize: function() {
      this.listenTo(svs.tipset.models.play, 'change', this.toggleSingleRow);
      this.listenTo(
        svs.tipset.models.weekPicker,
        'nrOfWeeksUpdated',
        this.update
      );
      var defaultAmount = this.get('sportkryssBet') ? 0 : '0';
      this.set('defaultsportkryssAmount', defaultAmount);
    },

    handleOnSportkryssChange: function(
      sportkryssBet,
      isValid,
      sportkryssNumber
    ) {
      var options;
      if (sportkryssBet) {
        sportkryssBet.betProperties = this.getBetProperties();
        options = {
          sportkryssBet: sportkryssBet,
          isValid: isValid,
          sportkryssNr: sportkryssNumber
        };
        this.update(options);
        this.trigger('sportkryssUpdated');
      } else {
        this.clearAll();
      }
    },

    clearAll: function() {
      this.set(this.defaults, { silent: true });
      this.save();
      this.trigger('sportkryssUpdated');
    },

    update: function(options) {
      var sportkryssBet, nrOfWeeks, sportkryssAmount, sportkryssNumber, isValid;

      if (options) {
        sportkryssBet = options.sportkryssBet;
        isValid = options.isValid;
        sportkryssNumber = options.sportkryssNumber;
      } else {
        sportkryssBet = this.get('sportkryssBet');
        isValid = this.get('isValid');
        sportkryssNumber = this.get('sportkryssNr');
      }

      if (sportkryssBet) {
        nrOfWeeks =
          svs.tipset.models.gameDefinitions.hasWeekPicker() &&
          svs.tipset.models.weekPicker
            ? svs.tipset.models.weekPicker.getNumberOfWeeks()
            : 1;
        sportkryssAmount = parseInt(sportkryssBet.betAmountSalesGroup1, 10);

        sportkryssBet.numDraws = nrOfWeeks;

        this.set(
          {
            sportkryssBet: sportkryssBet,
            isValid: isValid,
            sportkryssNr: sportkryssNumber,
            sportkryssAmount: sportkryssAmount * nrOfWeeks,
            numDraws: nrOfWeeks
          },
          { silent: true }
        );
      }
      this.save();
    },

    toggleSingleRow: function() {
      if (
        svs.tipset.objects.localstorageHandler &&
        svs.tipset.objects.localstorageHandler.dataFromLocalStorage &&
        svs.tipset.objects.localstorageHandler.dataFromLocalStorage
          .sportkryssBet
      ) {
        var sportkryssBet =
            svs.tipset.objects.localstorageHandler.dataFromLocalStorage
              .sportkryssBet,
          isValid =
            svs.tipset.objects.localstorageHandler.dataFromLocalStorage
              .sportkryssIsValid,
          options;

        options = {
          sportkryssBet: sportkryssBet,
          isValid: isValid,
          sportkryssNr: sportkryssBet.jokerBoards[0].boardData
        };

        this.update(options);
        this.trigger('sportkryssUpdated');
      }
    },

    getBetProperties: function() {
      var marketplaceAccount = svs.tipset.helpers.getMarketplaceAccount();

      if (
        marketplaceAccount &&
        svs.core.userSession.hasRole(svs.core.userSession.roles.RETAILER)
      ) {
        return [
          svs.tipset.constants.BET_PROPERTIES_MARKETPLACE,
          svs.tipset.constants.BET_PROPERTIES_MARKETPLACE_RETAIL
        ];
      } else if (marketplaceAccount) {
        return [svs.tipset.constants.BET_PROPERTIES_MARKETPLACE];
      }
    },

    getsportkryssWager: function() {
      var sportkryssWager = this.get('sportkryssBet') ? {} : undefined;
      if (sportkryssWager) {
        _.extend(sportkryssWager, this.get('sportkryssBet'));
        sportkryssWager.betAmountSalesGroup1 = svs.utils.format.CurrencyAsJupiterString(
          this.get('sportkryssAmount')
        );
      }

      return sportkryssWager;
    },

    save: function() {
      svs.tipset.objects.localstorageHandler.saveDataToLocalStorage();
    }
  });
})(Backbone, _, svs);

 })(window);